module.exports = __webpack_public_path__ + "img/ke_fu.43b91efe.png";